<template>
  <div id="selectTask" class="container overflow-y">
    <NavBar :title="$t('general.myShopping')" :show-logo="false" />
    <div class="order-list">
      <el-row
        v-if="haveActiveOrders">
        <div class="section-subtitle mb-10">
          <span>{{ $t('general.activeOrders') }}</span>
        </div>
        <order-item
          v-for="order in activeOrders"
          :key="order.folio"
          :folio="order.folio"
          :status="order.status"
          :date="order.updatedAt"
          :driver="order.deliveryMan"
          :client="order.customer"
          class="cursor-pointer"
          @click.native="goToFolio(order.folio)" />
      </el-row>
      <el-row
        v-if="haveOrdersCompleted"
        class="mt-20">
        <div class="section-subtitle mb-10">
          <span>{{ $t('general.orderCompleted') }}</span>
        </div>
        <order-item
          v-for="order in ordersCompleted"
          :key="order.folio"
          :folio="order.folio"
          :status="order.status"
          :date="order.endedAt"
          :driver="order.deliveryMan"
          :client="order.customer"
          class="cursor-pointer"
          @click.native="goToFolio(order.folio)" />
      </el-row>
    </div>
    <Footer />
  </div>
</template>
<script>
// Utils
import { mapGetters } from 'vuex'
import { object, inProgres, completed } from '@/utils/status'
import { removeFolio } from '@/utils/cookies'

// Components
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import OrderItem from '@/components/Orders/OrderItem'

// Constants
import DRIVER_CONSTANTS from '@/constants/driverConstants'

export default {
  name: 'TaskOrders',
  components: {
    NavBar,
    Footer,
    OrderItem
  },
  computed: {
    ...mapGetters(['tasks']),
    incompleteTasks: function() {
      return this.tasks.filter((task) => {
        return (task.status === object.COMPLETED || inProgres.includes(task.status)) && typeof task.rate === 'undefined'
      })
    },
    activeOrders: function() {
      return this.incompleteTasks.filter(task => {
        return inProgres.includes(task.status)
      })
    },
    ordersCompleted: function() {
      return this.incompleteTasks.filter(task => {
        return completed.includes(task.status)
      })
    },
    haveActiveOrders: function() {
      return this.activeOrders.length > 0
    },
    haveOrdersCompleted: function() {
      return this.ordersCompleted.length > 0
    },
    isRatingAvailable: function() {
      return DRIVER_CONSTANTS.IS_RATING_AVAILABLE
    }
  },
  beforeMount() {
    removeFolio()
    if (this.tasks.length < 1) {
      this.$router.replace('/')
    }
  },
  methods: {
    goToFolio: function(folio) {
      this.$store.commit('TO_HOME', false)
      this.$router.push({ path: `/folio/${folio}` })
    }
  }
}
</script>
